module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    style: (_vm.getStyle)
  }, [(_vm.isUploadFile) ? _c('label', {
    directives: [{
      name: "popover",
      rawName: "v-popover:tooltip",
      value: (_vm.t(_vm.getTitle)),
      expression: "t(getTitle)",
      arg: "tooltip"
    }],
    staticClass: "btn btn-sm btn-info"
  }, [_vm._v("\n        " + _vm._s(_vm.t(_vm.getName)) + "\n        "), _c('input', {
    ref: "file",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "id": "file"
    },
    on: {
      "change": _vm.onClickUploadFile
    }
  })]) : _c('button', {
    directives: [{
      name: "popover",
      rawName: "v-popover:tooltip",
      value: (_vm.t(_vm.getTitle)),
      expression: "t(getTitle)",
      arg: "tooltip"
    }],
    staticClass: "btn btn-sm btn-confirm",
    class: !_vm.getActive ? 'mark-disabled' : '',
    style: ({
      'background-color': _vm.getBackgroundColor
    }),
    attrs: {
      "disabled": !_vm.getActive
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.onClick($event)
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.t(_vm.getName)) + "\n    ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-30d180a0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/grid/ActionComponent.vue
// module id = 1260
// module chunks = 2